import { useQuery } from '@tanstack/react-query';
import { WIKI_MEDIA_LIST } from 'src/constants/queryKeys';
import axiosInstance from 'src/utils/axios';

export const networkGetMediaWikiList = async (data, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`MediaWiki/List/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchMediaWikiList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [WIKI_MEDIA_LIST, payload, pageIndex],
    queryFn: () => networkGetMediaWikiList(payload, pageIndex, pageSize),
  });
}

export const networkGetMediaWikiInfo = async (wikiMediaId) => {
  const res = await axiosInstance.post(`MediaWiki/Info/${wikiMediaId}`);
  return res;
};

export const networkCreateMediaWiki = async (data) => {
  const res = await axiosInstance.post('MediaWiki/Insert', data);
  return res;
};

export const networkUpdateMediaWiki = async (wikiMediaId, data) => {
  const res = await axiosInstance.post(`MediaWiki/Update/${wikiMediaId}`, data);
  return res;
};

export const networkRemoveMediaWiki = async (wikiMediaId) => {
  const res = await axiosInstance.post(`MediaWiki/Remove/${wikiMediaId}`);
  return res;
};
